import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

// SVG Icons
import { ReactComponent as Collapsedlogo } from '../assets/svg/US-collapsed.svg'
import { ReactComponent as CollapsedEarlylogo } from '../assets/svg/US-Early-collapsed.svg'
import { ReactComponent as FullLogo } from '../assets/svg/US-full.svg'
import { ReactComponent as EarlyFullLogo } from '../assets/svg/US-Early-full.svg'

const SidebarLogo = ({ collapsed, primaryUI }) => {
    const history = useHistory()

    const handleLogoClick = () => {
        history.push('/dashboard')
    }

    const [showCollapsed, setShowCollapsed] = useState(collapsed)

    useEffect(() => {
        let timeout

        if (collapsed) {
            setShowCollapsed(true)
        } else {
            timeout = setTimeout(() => {
                setShowCollapsed(false)
            }, 200)
        }

        return () => clearTimeout(timeout)
    }, [collapsed])

    return (
        <div className="flex flex-row items-center justify-center mt-6 min-h-[100px] min-w-6 relative cursor-pointer" onClick={handleLogoClick}>
            <div
                className={`upstrive-logo-collapsed absolute transition-opacity duration-300 ${collapsed ? 'opacity-100' : 'opacity-0'}`}
                style={{ display: showCollapsed ? 'block' : 'none' }}
            >
                {!primaryUI ? <Collapsedlogo /> : <CollapsedEarlylogo />}
            </div>

            <div
                className={`upstrive-logo-collapsed absolute transition-opacity duration-300 ${!collapsed ? 'opacity-100' : 'opacity-0'}`}
                style={{ display: showCollapsed ? 'none' : 'block' }}
            >
                {!primaryUI ? <FullLogo /> : <EarlyFullLogo />}
            </div>
        </div>
    )
}

export default SidebarLogo
